import React from 'react';

export const CollapsibleSectionContext = React.createContext<{
  collapsed: boolean;
  setCollapsed: (val: boolean) => void;
  setHasLabel: React.Dispatch<React.SetStateAction<boolean>>;
  hasLabel: boolean;
  id?: string;
  testId?: string;
}>({
  collapsed: true,
  setCollapsed: () => null,
  setHasLabel: () => null,
  hasLabel: false,
  id: '',
  testId: undefined,
});
